import { render, staticRenderFns } from "./PieBarWrapper.vue?vue&type=template&id=6d56ea3a&"
import script from "./PieBarWrapper.vue?vue&type=script&lang=js&"
export * from "./PieBarWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports